import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UserSessionStorageService {
   private readonly hasSessionLocalStorageKey = '__ndt-has-session';

   private readonly applicationVersionStorageKey = '__ndt-application-version';

   getHasSession(): boolean {
      return localStorage.getItem(this.hasSessionLocalStorageKey) === true.toString();
   }

   setHasSession(hasSession: boolean): void {
      localStorage.setItem(this.hasSessionLocalStorageKey, hasSession.toString());
   }

   removeHasSession(): void {
      localStorage.removeItem(this.hasSessionLocalStorageKey);
   }

   getApplicationVersion(): string | null {
      return localStorage.getItem(this.applicationVersionStorageKey);
   }

   setApplicationVersion(applicationVersion: string): void {
      localStorage.setItem(this.applicationVersionStorageKey, applicationVersion);
   }

   removeApplicationVersion(): void {
      localStorage.removeItem(this.applicationVersionStorageKey);
   }

   clearLocalStorage(): void {
      localStorage.clear();
   }
}
